import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AI_GENERATED_ICON, ICON } from '@core/util/icon';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { SelectSnapshot, ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { LawyerSearchState } from '@state/algolia-search/lawyer-search';
import { LawyerSearchDispatch } from '@state/algolia-search/lawyer-search/dispatch';
import { LawFirm } from '@models/lawFirms';
import { MatterFieldMappings } from '@models/matter';
import { LawFirmEmployee, LawFirmEmployeeType } from '@models/lawFirms';
import { Employee } from '@models/company';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterDispatch } from '@state/matter';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';
import { ActivatedRoute } from '@angular/router';
import { openClose } from '@core/animations/animations';
import { GlobalDataManagementRequestDispatch } from 'src/app/global-data-management/state/global-data-management/global-data-management.request.dispatch';
import { TestHooks } from './lawyer-side-form.hooks';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';

@UntilDestroy()
@Component({
	selector: 'app-lawyer-side-form',
	templateUrl: './lawyer-side-form.component.html',
	animations: [openClose(300)],
	standalone: false,
})
export class LawyerSideFormComponent {
	testHooks = TestHooks;
	public _lawyerName = '';
	public ICON = ICON;
	public _focus = false;
	public hoverShadow = true;
	public showCreateForm = false;
	public AI_ICON = AI_GENERATED_ICON.icon;
	public AI_CLASSES = AI_GENERATED_ICON.classes;
	public AI_TOOLTIP = AI_GENERATED_ICON.tooltip;

	@ViewSelectSnapshot(LawyerSearchState.getList) searchResult;

	@Input() lawFirm: LawFirm;
	@Output() onSelectLawyer = new EventEmitter<Employee>();
	@Output() onRemoveLawyer = new EventEmitter();
	@Output() onFocus = new EventEmitter();

	@SelectSnapshot(SelectedMatter.id) saleId;
	@Select(SelectedMatter.getFieldMappings)
	fieldMappings$: Observable<MatterFieldMappings>;

	constructor(
		private matterDispatch: MatterDispatch,
		private lawyerSearchDispatch: LawyerSearchDispatch,
		private navigationService: NavigationService,
		private globalStoreDispatch: GlobalDataManagementRequestDispatch,
		private route: ActivatedRoute,
	) {}

	_onFocus() {
		this.onFocus.emit();
		this._focus = true;
	}

	setLawyer(ev: DropdownResult<LawFirmEmployee>) {
		if (ev.group === 1) {
			this.onSelectLawyer.emit(ev.result);
		}
	}

	removeLawyer() {
		this.onRemoveLawyer.emit();
		this._lawyerName = '';
	}

	createLawyer() {
		this.showCreateForm = true;
	}

	searchLawyer(value) {
		this.lawyerSearchDispatch.Search({
			searchValue: value,
			lawFirmId: this.lawFirm.id,
			cardId: this.lawFirm.leap?.cardId,
			role: LawFirmEmployeeType.LAWYER,
		});
	}

	updateLawyer() {
		this.navigationService.goToUrl('edit-lawyer', null, {
			relativeTo: this.route,
			state: { lawFirm: this.lawFirm },
		});
	}

	lawyerDropdownOptionSelect(event) {
		switch (event.result.name) {
			case 'Edit':
				this.updateLawyer();
				break;
			case 'Remove':
				this.removeLawyer();
				break;
		}
	}

	_onCreate(event: LawFirmEmployee) {
		event.role = LawFirmEmployeeType.LAWYER;
		this.matterDispatch.CreateLawFirmEmployee(
			this.saleId,
			event,
			this.lawFirm.id,
		);
		this.globalStoreDispatch.RequestLawFirmEmployeeChange(
			this.lawFirm.id,
			event,
		);

		this.showCreateForm = false;
	}

	_onCancel() {
		this.showCreateForm = false;
	}
}
